module.exports = __webpack_public_path__ + "img/alkalmazasok_avi.74de54ef.png";